import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { ANALYST, DIGEST } from 'reporting-data/constants/aiSettings';
import { getAIInsightsSummaryStyle } from 'reporting-data/report/reportGetters';
import { setAIInsightsSummaryStyle } from 'reporting-data/report/reportSetters';
import { useAIInsightsTracker } from '../useAIInsightsTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT = 'DEFAULT';
const actions = {
  [ANALYST]: 'styleAnalyst',
  [DIGEST]: 'styleDigest',
  [DEFAULT]: 'styleDefault'
};
export function AISettingsSummaryStyle({
  previewReport,
  onPreviewReportChange
}) {
  const summaryStyle = getAIInsightsSummaryStyle(previewReport);
  const {
    trackAIInsightsEvent
  } = useAIInsightsTracker(previewReport);
  function onSummaryStyleChange(newSummaryStyle) {
    const updatedReport = setAIInsightsSummaryStyle(previewReport, newSummaryStyle === DEFAULT ? undefined : newSummaryStyle);
    onPreviewReportChange(updatedReport);
    trackAIInsightsEvent({
      action: actions[newSummaryStyle]
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18n.text('reporting-enablement.aiInsightsSettings.style.title'),
    children: /*#__PURE__*/_jsx(ToggleGroup, {
      name: "ai-insights-summary-style",
      paddingInline: "50",
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "500",
        alignItems: "stretch",
        children: [/*#__PURE__*/_jsx(SelectableButton, {
          selected: summaryStyle === DIGEST,
          onClick: () => onSummaryStyleChange(DIGEST),
          title: I18n.text('reporting-enablement.aiInsightsSettings.style.digest'),
          description: I18n.text('reporting-enablement.aiInsightsSettings.style.shortForm')
        }), /*#__PURE__*/_jsx(SelectableButton, {
          selected: !summaryStyle,
          onClick: () => onSummaryStyleChange(DEFAULT),
          title: I18n.text('reporting-enablement.aiInsightsSettings.default'),
          description: I18n.text('reporting-enablement.aiInsightsSettings.style.midLength')
        }), /*#__PURE__*/_jsx(SelectableButton, {
          selected: summaryStyle === ANALYST,
          onClick: () => onSummaryStyleChange(ANALYST),
          title: I18n.text('reporting-enablement.aiInsightsSettings.style.analyst'),
          description: I18n.text('reporting-enablement.aiInsightsSettings.style.longForm')
        })]
      })
    })
  });
}